import { createRouter, createWebHashHistory } from 'vue-router'
import CourseLayout from '@/layout/CourseLayout.vue'
import PaperLayout from '@/layout/PaperLayout.vue'
import { getMenuNavApi } from '@/api/newPage/Common'

// 匹配views里面所有的.vue文件，动态引入
// const modules = import.meta.glob('/src/views/**/*.vue')

const routes: any[]  = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/home.vue')
  },
  {
    path: '/diamond/index',
    name: 'diamondManagement',
    component: () => import('../views/DiamondManagement.vue')
  },
  {
    path: '/diamondSkin/index',
    name: 'ActivityDiamondSkin',
    component: () => import('../views/ActivityDiamondSkin.vue')
  },
  {
    path: '/exam/index',
    name: 'examManagement',
    component: () => import('../views/ExamManagement.vue')
  },
  {
    path: '/contracts/index',
    name: 'contractPartner',
    component: () => import('../views/ContractPartner.vue')
  },
  {
    path: '/VideoManagement/index',
    name: 'VideoManagement',
    component: () => import('../views/video/VideoManagement/index.vue')
  },
  {
    path: '/HuaweiBlacklist/index',
    name: 'HuaweiBlacklist',
    component: () => import('../views/newPage/TecManagement/HuaweiBlacklist/index.vue')
  },
  {
    path: '/userCommentRisk/index',
    name: 'userCommentRisk',
    component: () => import('../views/video/userCommentRisk/index.vue')
  },
  {
    path: '/VideoManagement/reply',
    name: 'VideoManagementReply',
    component: () => import('../views/video/reply.vue')
  },
  {
    path: '/VideoManagement/comment',
    name: 'VideoManagementComment',
    component: () => import('../views/video/comment.vue')
  },
  {
    path: '/ossUpload/index',
    name: 'OssUpload',
    component: () => import('../views/OssUpload.vue')
  },
  {
    path: '/techWhitelist/index',
    name: 'techWhitelist',
    component: () => import('../views/TechWhitelist.vue')
  },
  {
    path: '/integrityManagement/index',
    name: 'integrityManagement',
    component: () => import('../views/newPage/integrityManagement/index.vue')
  },
  {
    path: '/appBanner/index',
    name: 'appBanner',
    component: () => import('../views/AppBannerManagement.vue')
  },
  {
    path: '/partnerReApply/index',
    name: 'partnerReApply',
    component: () => import('../views/PartnerReApply.vue')
  },
  {
    path: '/IPUnnormal/index',
    name: 'IPUnnormal',
    component: () => import('../views/orderManagement/IPUnnormal/index.vue')
  },
  {
    path: '/TecDataAudit/index',
    name: 'TecDataAudit',
    component: () => import('../views/newPage/TecManagement/TecDataAudit.vue')
  },
  {
    path: '/trainTechCertificate/index',
    name: 'trainTechCertificate',
    component: () => import('../views/trainTechCertificate/index.vue')
  },
  {
    path: '/TecSkillManagement/index',
    name: 'TecSkillManagement',
    component: () => import('../views/newPage/TecManagement/TecSkillManagement.vue')
  },
  {
    path: '/contentReport/index',
    name: 'MediaReport',
    component: () => import('../views/video/MediaReport/index.vue')
  },
  {
    path: '/userReportManage/index',
    name: 'userReportManage',
    component: () => import('../views/video/userReportManage/index.vue')
  },
  {
    path: '/PopupList/index',
    name: 'appPopupinfo',
    component: () => import('../views/appPopupinfo/index.vue')
  },
  {
    path: '/PopupList/index',
    name: 'appPopupinfo',
    component: () => import('../views/appPopupinfo/index.vue')
  },
  {
    path: '/partnerSetCity/index',
    name: 'partnerSetCity',
    component: () => import('../views/newPage/partnerSetCity/index.vue')
  },
  {
    path: '/threeOrderTask/index',
    name: 'threeOrderTask',
    component: () => import('../views/newPage/threeOrderTask/index.vue')
  },
  {
    path: '/withdraw/userWithdraw',
    name: 'userWithdraw',
    component: () => import('../views/withdraw/userWithdraw.vue')
  },
  {
    path: '/withdraw/userWithdrawLog',
    name: 'userWithdrawLog',
    component: () => import('../views/withdraw/userWithdrawLog.vue')
  },
  {
    path: '/menu/index',
    name: 'menuList',
    component: () => import('../views/newPage/menu/index.vue')
  },
  {
    path: '/hdLecture/index',
    name: 'hdLecture',
    component: () => import('../views/newPage/hdLecture/index.vue')
  },
  {
    path: '/pickGoodTech/index',
    name: 'pickGoodTech',
    component: () => import('../views/newPage/pickGoodTech/index.vue')
  },
  {
    path: '/examMonthly/index',
    name: 'examMonthly',
    component: () => import('../views/monthExamManage/examMonthly/index.vue')
  },
  {
    path: '/merchantExamMonthly/index',
    name: 'merchantExamMonthly',
    component: () => import('../views/monthExamManage/merchantExamMonthly/index.vue')
  },
  {
    path: '/examMonthlyStatistics/index',
    name: 'examMonthlyStatistics',
    component: () => import('../views/monthExamManage/examMonthlyStatistics/index.vue')
  },
  {
    path: '/techQuestion/index',
    name: 'techQuestion',
    component: () => import('../views/newPage/techQuestion/index.vue')
  },
  {
    path: '/agentTechWhiteList/index',
    name: 'agentTechWhiteList',
    component: () => import('../views/newPage/interviewTech/agentTechWhiteList.vue')
  },
  {
    path: '/wyCouponReceiveActivity/index',
    name: 'wyCouponReceiveActivity',
    component: () => import('../views/activityManagement/wyCouponReceiveActivity/index.vue')
  },
  {
    path: '/interviewTech/index',
    name: 'interviewTech',
    component: () => import('../views/newPage/interviewTech/index.vue')
  },
  {
    path: '/maliceOrderList/index',
    name: 'maliceOrderList',
    component: () => import('../views/orderManagement/maliceOrderList/index.vue')
  },
  {
    path: '/pushActivityPopManagement/index',
    name: 'pushActivityPopManagement',
    component: () => import('../views/newPage/pushActivityPopManagement/index.vue')
  },
  {
    path: '/streamProduct/index',
    name: 'streamProduct',
    component: () => import('../views/activityManagement/streamProduct/index.vue')
  },
  {
    path: '/streamOrder/index',
    name: 'streamOrder',
    component: () => import('../views/activityManagement/streamOrder/index.vue')
  },
  {
    path: '/UserNPSResearch/index',
    name: 'UserNPSResearch',
    component: () => import('../views/newPage/UserNPSResearch/index.vue')
  },
  {
    path: '/GengyunSignWhilteList/index',
    name: 'GengyunSignWhilteList',
    component: () => import('../views/withdraw/GengyunSignWhilteList/index.vue')
  },
  {
    path: '/mallOrderComment/index',
    name: 'mallOrderComment',
    component: () => import('../views/orderManagement/mallOrderComment/index.vue')
  },
  {
    path: '/WyTopTechBlackList/index',
    name: 'WyTopTechBlackList',
    component: () => import('../views/newPage/WyTopTechBlackList/index.vue')
  },
  {
    path: '/pulicSeaUpload/index',
    name: 'pulicSeaUpload',
    component: () => import('../views/newPage/pulicSeaUpload/index.vue')
  },
  {
    path: '/threePartyComplain/index',
    name: 'threePartyComplain',
    component: () => import('../views/newPage/threePartyComplain/index.vue')
  },
  {
    path: '/TechUnbanInterviewRecord/index',
    name: 'TechUnbanInterviewRecord',
    component: () => import('../views/newPage/TecManagement/TechUnbanInterviewRecord/index.vue')
  },
  {
    path: '/CommentFilterStar/index',
    name: 'CommentFilterStar',
    component: () => import('../views/orderManagement/CommentFilterStar/index.vue')
  },
  {
    path: '/RemarkTechManagement/index',
    name: 'RemarkTechManagement',
    component: () => import('../views/newPage/TecManagement/RemarkTechManagement/index.vue')
  },
  // {
  //   path: '/imChat/index',
  //   name: 'imChat',
  //   component: () => import('../views/ImChat.vue')
  // },
  //商学院
  {
    path: '/course',
    component: CourseLayout,
    children: [
      {
        path: 'index',
        name: 'Course',
        component: () => import('@/views/course/index.vue')
      },
      {
        path: 'category',
        name: 'CourseCategory',
        meta: {
          type: '1'
        },
        component: () => import('@/views/category/index.vue')
      }
    ]
  },
  {
    path: '/question',
    component: PaperLayout,
    children: [
      {
        path: 'index',
        name: 'Question',
        component: () => import('@/views/question/index.vue')
      },
      {
        path: 'category',
        name: 'QuestionCategory',
        meta: {
          type: '2'
        },
        component: () => import('@/views/category/index.vue')
      }
    ]
  },
  {
    path: '/paper',
    component: PaperLayout,
    children: [
      {
        path: 'index',
        name: 'Paper',
        component: () => import('@/views/paper/index.vue')
      },
      {
        path: 'edit',
        component: () => import('@/views/paper/edit.vue')
      },
      {
        path: 'preview',
        component: () => import('@/views/paper/preview.vue')
      },
      {
        path: 'log',
        name: 'PaperLog',
        component: () => import('@/views/paper/log.vue')
      }
    ]
  },
  {
    path: '/config',
    component: CourseLayout,
    children: [
      {
        path: 'banners',
        name: 'Banners',
        component: () => import('@/views/config/index.vue')
      },
      {
        path: 'menus',
        name: 'Menus',
        component: () => import('@/views/config/index.vue')
      }
    ]
  },
  {
    path: '/PartnerDataAudit/index',
    name: 'PartnerDataAudit',
    component: () => import('../views/newPage/TecManagement/PartnerDataAudit.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach(async(to, from, next) => {
  if (window.location.href.includes('isInner=1')) {
    localStorage.setItem('permissions', '')
    const t: any = await getMenuNavApi()
    localStorage.setItem('permissions', JSON.stringify(t?.permissions))
  }
  next()
})

export default router
